var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 3.19922H4.79995C3.91595 3.19922 3.19995 3.91522 3.19995 4.79922V19.1992C3.19995 20.0832 3.91595 20.7992 4.79995 20.7992H19.2C20.084 20.7992 20.8 20.0832 20.8 19.1992V4.79922C20.8 3.91522 20.0832 3.19922 19.2 3.19922ZM18.1512 10.7784C18.0472 10.788 17.9424 10.7944 17.8368 10.7944C16.6408 10.7944 15.5896 10.18 14.9776 9.24962C14.9776 11.6888 14.9776 14.4648 14.9776 14.5112C14.9776 16.6592 13.236 18.4 11.0888 18.4C8.94155 18.3992 7.19995 16.6576 7.19995 14.5104C7.19995 12.3624 8.94155 10.6216 11.0888 10.6216C11.1704 10.6216 11.2496 10.6288 11.3288 10.6336V12.5504C11.2488 12.5408 11.1712 12.5264 11.0888 12.5264C9.99275 12.5264 9.10395 13.4152 9.10395 14.5112C9.10395 15.6072 9.99195 16.496 11.0888 16.496C12.1856 16.496 13.1536 15.632 13.1536 14.536C13.1536 14.492 13.1728 5.60002 13.1728 5.60002H15.004C15.176 7.23762 16.4984 8.53042 18.1512 8.64882V10.7784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4571d353a99a9b04aba74932c4783386.svg";
export { ForwardRef as ReactComponent };